/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EForeignDocument } from "../types/EForeignDocument.ts";

/**
 * @description 1 = IdentificationDocument | 2 = Passport | 3 = RneRnm |
 */
export const eForeignDocumentSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = IdentificationDocument | 2 = Passport | 3 = RneRnm | ",
  ) as unknown as ToZod<EForeignDocument>;
